import { RadioGroup } from 'informed'
import React from 'react'
import { branch, compose } from 'recompose'
import { withFieldSubmit } from '../Form'
import PropTypes from 'prop-types'

const SmartRadioGroup = ({ smartSubmit, field, value, defaultValue, children, ...rest }) => {
	return (
		<RadioGroup value={value} defaultValue={defaultValue} field={field} onChange={e => {
			if (rest.onChange) {
				rest.onChange(e)
			}
			if (smartSubmit) {
				smartSubmit.submit(e)
			}
		}} >
			{(children)}
		</RadioGroup>
	)
}

SmartRadioGroup.propTypes = {
	field: PropTypes.string,
	value: PropTypes.string,
	defaultValue: PropTypes.string
}

export default compose(
	branch(
		({ noForm, field }) => (!noForm && field),
		withFieldSubmit
	)
)(SmartRadioGroup)
